import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Home", href: "#home", testid: "nav-link-home" },
  { label: "About", href: "#about", testid: "nav-link-about" },
  { label: "Experience", href: "#experience", testid: "nav-link-experience" },
  { label: "Services", href: "#services", testid: "nav-link-services" },
  { label: "Skills", href: "#skills", testid: "nav-link-skills" },
  { label: "Portfolio", href: "#portfolio", testid: "nav-link-portfolio" },
  { label: "Contact", href: "#contact", testid: "nav-link-contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    if (window.__lenis) window.__lenis.scrollTo(href, { duration: 1.3 });
    else document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <header
        data-testid="site-header"
        className={`fixed inset-x-0 top-0 z-40 transition-all duration-500 ${
          scrolled ? "bg-white py-3 shadow-md" : "bg-transparent py-5"
        }`}
      >
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6">
          <a
            data-testid="nav-logo"
            href="#home"
            onClick={(e) => go(e, "#home")}
            className={`text-2xl font-bold tracking-tight transition-colors duration-500 ${
              scrolled ? "text-[#212529]" : "text-white"
            }`}
          >
            Harshith<span className="text-accent">.</span>
          </a>
          <nav className="hidden items-center gap-8 lg:flex">
            {LINKS.map((l) => (
              <a
                key={l.label}
                data-testid={l.testid}
                href={l.href}
                onClick={(e) => go(e, l.href)}
                className={`group relative text-sm font-normal transition-colors duration-300 ${
                  scrolled ? "text-[#212529]/80 hover:text-[#212529]" : "text-white/80 hover:text-white"
                }`}
              >
                {l.label}
                <span className="absolute -bottom-1 left-0 h-0.5 w-0 bg-accent transition-all duration-400 group-hover:w-full" />
              </a>
            ))}
          </nav>
          <button
            data-testid="mobile-menu-btn"
            onClick={() => setOpen(true)}
            aria-label="Open menu"
            className={`lg:hidden ${scrolled ? "text-[#212529]" : "text-white"}`}
          >
            <Menu className="h-7 w-7" />
          </button>
        </div>
      </header>

      {open && (
        <div data-testid="mobile-menu" className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-7 bg-[#111]/[0.98]">
          <button
            data-testid="mobile-menu-close-btn"
            onClick={() => setOpen(false)}
            aria-label="Close menu"
            className="absolute right-6 top-6 text-white"
          >
            <X className="h-8 w-8" />
          </button>
          {LINKS.map((l) => (
            <a
              key={l.label}
              data-testid={`mobile-${l.testid}`}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              className="text-2xl font-light tracking-wide text-white/85 transition-colors hover:text-accent"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </>
  );
};
